import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../api/axios.js";

const Password = () => {
    // const location = useLocation();
    // const empId = location.state?.empId;
    const navigate = useNavigate();

    const [empId, setEmpId] = useState("");
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    // const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const canSubmit = empId.trim() !== "" && password.trim() !== "";

    const loginHandling = async (event) => {
        event.preventDefault();


        try {
            // for regular login and get token
            const res = await api.post("/auth/login", {
                employeeId: empId,
                password,
            });
            const token = res.data.token;
            //store token
            localStorage.setItem("token", token);

            if(res.data.role === "manager"){
                navigate("/manager/dashboard");
            } else if(res.data.role === "employee"){
                navigate("/dashboard");
            }
            
        } catch (err) {
            console.error(err);
            let message = "Request failed";
            if (err.response && err.response.data) {
                if (err.response.data.message) {
                    message = err.response.data.message;
                } else if (Array.isArray(err.response.data.errors)) {
                    message = err.response.data.errors.map((e) => e.msg || e.msg).join(", ");
                }
            }
            alert(message);
        }
    };


    return (
        <>
            <div className="logo">
                <img src="/images/logo-circle-dark.png" alt="logo" className="circle"/>
                <img src="/images/brevia-brown.png" className="brevia"></img>
            </div>
            <div className="logo-wrapper">
                <div className="login-wrapper">
                    <h2>Log In</h2>
                    <form onSubmit={loginHandling} className="password_form">
                        <input
                            type="hidden"
                            value={empId}
                            readOnly
                        />
                        <label htmlFor="emp-id">
                            Employee ID
                        </label>
                        <div className="input_wrapper">
                            <input
                                id="emp-id"
                                type="text"
                                placeholder="Enter your employee ID"
                                value={empId}
                                onChange={(e) => setEmpId(e.target.value)}
                                autoComplete="username"
                                required
                            />
                           
                        </div>

                        <label htmlFor="pw">
                            Password
                        </label>
                        <div className="input_wrapper">
                            <input
                                id="pw"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                                required
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                            <a href="/forgotPassword" className="forgot-link">Forgot your password?</a>
                        </div>

                        <button type="submit" disabled={!canSubmit}>Submit</button>
                    </form>
                </div>
            </div>
        </>
    )

}

export default Password;